module.exports = __webpack_public_path__ + "static/media/custom-10000-medium.5132fe76.svg";